//
// ChangeController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/changes/NavigationTarget";

var ChangeController = createModule("BIRD::ChangeController", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        canUndo: [2],
        undo: [0],
        getUndoNavigationTarget: [1],
        redo: [0],
        canRedo: [2],
        getRedoNavigationTarget: [1],
    },
    ,
    ,
]);
export default ChangeController;
